import * as React from "react";
import { WithStyles, withStyles, createStyles } from './styles';
import { CircularProgress, Fade } from "./widget";

const styles = () => createStyles({

    root: {
        padding: 16,
        position: 'relative',
        width: '100%',
        zIndex: 1000,
    },

    spinner: {
        left: '50%',
        top: '50%',
        position: 'relative',
        animationDuration: '550ms',
        height: '100%',
    },
});

const View = withStyles(styles)((props: WithStyles<typeof styles>) => {

    const { classes } = props;

    return <div className={classes.root}>
        <Fade in style={{ transitionDelay: '500ms' }} unmountOnExit>
            <CircularProgress size={24} thickness={4} disableShrink variant="indeterminate" className={classes.spinner} />
        </Fade>
    </div>;
});

export {
    View as LoadingSpinner
}
